import React, { Component } from "react";
import { Button, Row, Col, Popconfirm } from "antd";
import UploadStepper from "./subcomponents/UploadStepper";
import { sendNotification } from "../../utils/index";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { updateMetadata } from "../../actions/UploadFolderAction";
import { getNewPermission } from "../../utils/index";
import { GB_TO_BYTE } from "../../utils/Constants/UploadsConstants";
import { getExplore } from "../../actions/AssetsExploreAction";
import { cleanDataBackRoot, getRoot } from "../../actions/AssetsRootAction";
import { getLastUploads } from "../../actions/AssetsLastUploadAction";
import { updateMetadataClient } from "../../actions/ClientAction";
import { v4 as uuidv4 } from "uuid";
class UploadFolderFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirm: false
    };
  }

  handleSetConfirm = value => {
    this.setState({ showConfirm: value });
  };

  render() {
    const {
      currentStep,
      intl,
      fileList,
      newColor,
      user,
      newMatrix,
      folderselect,
      contractedSpace,
      folderSpaceInBytes,
      start,
      workclient,
      root
    } = this.props;

    const showConfirm =
      currentStep === 2 &&
      this.props.usageRights &&
      (!this.props.dateFrom || !this.props.dateTo);

    const showButton =
      (currentStep === 2 &&
        this.props.usageRights === false &&
        !this.props.dateFrom &&
        !this.props.dateTo) ||
      (currentStep === 2 &&
        this.props.usageRights &&
        this.props.dateFrom &&
        this.props.dateTo);

    return (
      <Row
        style={{
          backgroundColor: "#E9EFF9",
          height: 100,
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          overflowX: "auto"
        }}
        span={24}
        type={"flex"}
        justify={"center"}
        align="middle"
      >
        <Col xs={24} sm={15}>
          <UploadStepper currentStep={currentStep} />
        </Col>
        <Col xs={24} sm={9}>
          <Row justify="space-between" gutter={[0, 8]}>
            <Col span={9} offset={2}>
              <Button
                type="default"
                style={{
                  width: "100%"
                }}
                onClick={() => {
                  if (currentStep > 0) {
                    this.props.updateMetadata({
                      currentStep: currentStep - 1
                    });
                  } else {
                    const filesInProgress = fileList.filter(
                      file => file.state === "inprogress"
                    );
                    if (filesInProgress.length !== 0) {
                      filesInProgress.forEach(file => {
                        if (file && file.uploadObject) {
                          file.uploadObject.abort();
                        }
                      });
                    }
                    this.props.updateMetadata({
                      fileList: [],
                      fileListToSave: [],
                      rootFolder: [],
                      tags: [],
                      dateFrom: null,
                      dateFromFormatted: null,
                      dateTo: null,
                      dateToFormatted: null,
                      usageRights: true,
                      usersEmails: [],
                      tagsProtocol: "",
                      route: "/",
                      currentStep: 0,
                      start: false,
                      saveFolderStructureLoading: false,
                      saveFolderStructureError: false,
                      showUploadFolderModal: false,
                      folderselect: "",
                      folderList: []
                    });
                    this.props.updateMetadataClient({
                      isUploading: false
                    });
                    const exploreId = this.props.location.pathname
                      .split("/")
                      .pop();
                    if (exploreId === "home") {
                      this.props.cleanDataBackRoot();
                      this.props.getRoot(workclient, root, true, [], 1, 40);
                      this.props.getLastUploads(workclient, root);
                    } else {
                      this.props.getExplore(
                        workclient,
                        exploreId,
                        1,
                        undefined,
                        undefined,
                        undefined,
                        20
                      );
                      this.props.getLastUploads(workclient, root);
                    }
                  }
                }}
              >
                {currentStep !== 0
                  ? intl.formatMessage({ id: "modal_back" })
                  : intl.formatMessage({ id: "modal_cancel" })}
              </Button>
            </Col>
            <Col span={9} offset={2}>
              {showConfirm && (
                <Popconfirm
                  title="Vas a subir assets sin derechos de uso. ¿Deseas continuar?"
                  onConfirm={() => {
                    this.props.updateMetadata({
                      currentStep: currentStep + 1,
                      usageRights: false
                    });
                    return;
                  }}
                  okText="seguir"
                  cancelText="volver a editar"
                >
                  <Button
                    type="primary"
                    style={{
                      width: "100%",
                      backgroundColor: newColor,
                      borderColor: newColor
                    }}
                    loading={currentStep < 3 ? false : start}
                    onClick={() => {
                      if (currentStep === 2) {
                        if (
                          this.props.dateFrom === undefined ||
                          !this.props.dateFrom ||
                          this.props.dateTo === undefined ||
                          !this.props.dateTo
                        ) {
                          this.handleSetConfirm(true);
                          return;
                        }
                        return;
                      } else {
                        this.handleSetConfirm(false);
                      }

                      if (currentStep === 0 && fileList.length === 0) {
                        sendNotification(
                          "warning",
                          intl,
                          `${intl.formatMessage({
                            id: "upload-folder-footer-m1"
                          })}`
                        );
                        return;
                      }
                      if (currentStep === 1) {
                        if (!folderselect) {
                          sendNotification(
                            "warning",
                            intl,
                            intl.formatMessage({ id: "trash-error-select" })
                          );
                          return;
                        }
                      }
                      if (currentStep < 3) {
                        this.props.updateMetadata({
                          currentStep: currentStep + 1
                        });
                        return;
                      }

                      const canUploadAssetInFolder =
                        user.clientRole !== "admin"
                          ? getNewPermission(folderselect, newMatrix, "upload")
                          : true;
                      if (!canUploadAssetInFolder) {
                        sendNotification(
                          "warning",
                          intl,
                          intl.formatMessage({ id: "permission_denied" })
                        );
                        return;
                      }
                      //folderSpaceInBytes: El espacio que actualmente está usando el usuario
                      //contractedSpaceInByte: El espacio total de almacenamiento en bytes
                      //toSaveSpace: El espacio que se se planea subir
                      const toSaveSpace = fileList.reduce((total, value) => {
                        return total + value.size;
                      }, 0);
                      const contractedSpaceInByte =
                        contractedSpace * GB_TO_BYTE;
                      if (
                        contractedSpaceInByte <
                        folderSpaceInBytes + toSaveSpace
                      ) {
                        sendNotification(
                          "warning",
                          intl,
                          intl.formatMessage({ id: "space_max_limit" })
                        );
                        return;
                      }
                      this.props.updateMetadata({
                        start: true,
                        uuid_session: uuidv4(),
                        fileIdsNotification: []
                      });
                      this.props.updateMetadataClient({
                        isUploading: true
                      });
                    }}
                  >
                    {currentStep < 3
                      ? intl.formatMessage({ id: "next_asset" })
                      : intl.formatMessage({ id: "complete" })}
                  </Button>
                </Popconfirm>
              )}

              {showButton && (
                <Button
                  type="primary"
                  style={{
                    width: "100%",
                    backgroundColor: newColor,
                    borderColor: newColor
                  }}
                  loading={currentStep < 3 ? false : start}
                  onClick={() => {
                    if (currentStep === 0 && fileList.length === 0) {
                      sendNotification(
                        "warning",
                        intl,
                        `${intl.formatMessage({
                          id: "upload-folder-footer-m1"
                        })}`
                      );
                      return;
                    }
                    if (currentStep === 1) {
                      if (!folderselect) {
                        sendNotification(
                          "warning",
                          intl,
                          intl.formatMessage({ id: "trash-error-select" })
                        );
                        return;
                      }
                    }
                    if (currentStep < 3) {
                      this.props.updateMetadata({
                        currentStep: currentStep + 1
                      });
                      return;
                    }

                    const canUploadAssetInFolder =
                      user.clientRole !== "admin"
                        ? getNewPermission(folderselect, newMatrix, "upload")
                        : true;
                    if (!canUploadAssetInFolder) {
                      sendNotification(
                        "warning",
                        intl,
                        intl.formatMessage({ id: "permission_denied" })
                      );
                      return;
                    }
                    //folderSpaceInBytes: El espacio que actualmente está usando el usuario
                    //contractedSpaceInByte: El espacio total de almacenamiento en bytes
                    //toSaveSpace: El espacio que se se planea subir
                    const toSaveSpace = fileList.reduce((total, value) => {
                      return total + value.size;
                    }, 0);
                    const contractedSpaceInByte = contractedSpace * GB_TO_BYTE;
                    if (
                      contractedSpaceInByte <
                      folderSpaceInBytes + toSaveSpace
                    ) {
                      sendNotification(
                        "warning",
                        intl,
                        intl.formatMessage({ id: "space_max_limit" })
                      );
                      return;
                    }
                    this.props.updateMetadata({
                      start: true,
                      uuid_session: uuidv4(),
                      fileIdsNotification: []
                    });
                    this.props.updateMetadataClient({
                      isUploading: true
                    });
                  }}
                >
                  {currentStep < 3
                    ? intl.formatMessage({ id: "next_asset" })
                    : intl.formatMessage({ id: "complete" })}
                </Button>
              )}

              {currentStep !== 2 && (
                <Button
                  type="primary"
                  style={{
                    width: "100%",
                    backgroundColor: newColor,
                    borderColor: newColor
                  }}
                  loading={currentStep < 3 ? false : start}
                  onClick={() => {
                    if (currentStep === 2) {
                      if (
                        this.props.dateFrom === undefined ||
                        !this.props.dateFrom ||
                        this.props.dateTo === undefined ||
                        !this.props.dateTo
                      ) {
                        this.handleSetConfirm(true);
                        return;
                      }
                      return;
                    } else {
                      this.handleSetConfirm(false);
                    }

                    if (currentStep === 0 && fileList.length === 0) {
                      sendNotification(
                        "warning",
                        intl,
                        `${intl.formatMessage({
                          id: "upload-folder-footer-m1"
                        })}`
                      );
                      return;
                    }
                    if (currentStep === 1) {
                      if (!folderselect) {
                        sendNotification(
                          "warning",
                          intl,
                          intl.formatMessage({ id: "trash-error-select" })
                        );
                        return;
                      }
                    }
                    if (currentStep < 3) {
                      this.props.updateMetadata({
                        currentStep: currentStep + 1
                      });
                      return;
                    }

                    const canUploadAssetInFolder =
                      user.clientRole !== "admin"
                        ? getNewPermission(folderselect, newMatrix, "upload")
                        : true;
                    if (!canUploadAssetInFolder) {
                      sendNotification(
                        "warning",
                        intl,
                        intl.formatMessage({ id: "permission_denied" })
                      );
                      return;
                    }
                    //folderSpaceInBytes: El espacio que actualmente está usando el usuario
                    //contractedSpaceInByte: El espacio total de almacenamiento en bytes
                    //toSaveSpace: El espacio que se se planea subir
                    const toSaveSpace = fileList.reduce((total, value) => {
                      return total + value.size;
                    }, 0);
                    const contractedSpaceInByte = contractedSpace * GB_TO_BYTE;
                    if (
                      contractedSpaceInByte <
                      folderSpaceInBytes + toSaveSpace
                    ) {
                      sendNotification(
                        "warning",
                        intl,
                        intl.formatMessage({ id: "space_max_limit" })
                      );
                      return;
                    }
                    this.props.updateMetadata({
                      start: true,
                      uuid_session: uuidv4(),
                      fileIdsNotification: []
                    });
                    this.props.updateMetadataClient({
                      isUploading: true
                    });
                  }}
                >
                  {currentStep < 3
                    ? intl.formatMessage({ id: "next_asset" })
                    : intl.formatMessage({ id: "complete" })}
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}
const mapStateToProps = state => {
  return {
    fileList: state.uploadFolder.fileList,
    start: state.uploadFolder.start,
    currentStep: state.uploadFolder.currentStep,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    usageRights: state.uploadFolder.usageRights,
    dateFrom: state.uploadFolder.dateFrom,
    dateTo: state.uploadFolder.dateTo,
    folderselect: state.uploadFolder.folderselect,
    contractedSpace:
      state.client && state.client.data
        ? state.client.data.contractedSpace
        : null,
    folderSpaceInBytes: state.storage.folderSpaceInBytes,
    workclient: state.client.workclient,
    root: state.client.root
  };
};

const mapDispatchToProps = {
  updateMetadata,
  getLastUploads,
  getRoot,
  getExplore,
  updateMetadataClient,
  cleanDataBackRoot
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderFooter))
);
